// @import depdendencies
import { IAppState } from 'app_events/app/types'
import React, { Component, ReactElement } from 'react'
import { connect } from 'react-redux'
// @end

// @import components
import { AppLayout } from '../index'
// @end

// @ADD Component types
interface AppProps {
  children: ReactElement
  app?: IAppState
}
interface AppState {}
class AppContainer extends Component<AppProps, AppState> {

  constructor(props: AppProps) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <AppLayout
        {...this.props}
      />
    )
  }
}

const mapStatesToProps = (state: any) => {
  return state
}


export default connect(mapStatesToProps)(AppContainer)
